import { FC } from 'react';
import {
  BooleanField,
  Datagrid,
  DateField,
  EditButton,
  List,
  TextField,
  CreateButton,
  TopToolbar,
  ReferenceField,
} from 'react-admin';

const ListActions = () => (
  <TopToolbar>
    <CreateButton label="Добавить файл" />
  </TopToolbar>
);

export const FilesList: FC = () => (
  <List title="Файлы" filter={{}} actions={<ListActions />}>
    <Datagrid>
      <TextField source="id" label="ID" />
      <TextField source="original_name" label="Название" />
      <TextField source="description" label="Описание" />
      <BooleanField source="is_active" label="Активен" />
      <TextField source="user_id" label="User ID" />
      <ReferenceField source="model_id" reference="models" label="Модель">
        <TextField source="name" />
      </ReferenceField>
      <DateField source="created_at" label="Создан" locales={['ru']} />
      <DateField source="updated_at" label="Изменен" locales={['ru']} />
      <EditButton label="Редактировать" />
    </Datagrid>
  </List>
);
